// extracted by mini-css-extract-plugin
export default {"sponsoredBanner":"UW-z","sponsoredTooltipWrapper":"VW-z","sponsoredTooltip":"WW-z","newCard":"XW-z"};